import { render, staticRenderFns } from "./EditorWidget.vue?vue&type=template&id=8ca98b1e&scoped=true"
import script from "./EditorWidget.vue?vue&type=script&lang=js"
export * from "./EditorWidget.vue?vue&type=script&lang=js"
import style0 from "./EditorWidget.vue?vue&type=style&index=0&id=8ca98b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca98b1e",
  null
  
)

export default component.exports